import React from 'react';
import { useNavigate } from 'react-router-dom';

const Footer = () => {
  const navigate = useNavigate();

  const handleEarlyAccess = () => {
    navigate('/registration-form');
  };
  const handleFAQs = () => {
    navigate('/faqs');
  };
  const handlePrivacyPolicy = () => {
    navigate('/privacy-policy');
  };
  const handleTermsAndCondition = () => {
    navigate('/terms-and-condition');
  };

  const socialLinks = {
    facebook: 'https://www.facebook.com/profile.php?id=61590044442857',
    instagram: 'https://www.instagram.com/smartacharya_global',
    linkedin: 'https://www.linkedin.com/company/smartacharya',
  };

  return (
    <footer className="bg-[#cc9754] py-5 mt-auto relative z-10 w-full">
      <div className="container mx-auto px-4">
        {/* Email row – moved up */}
        <div className="text-center mb-3">
          <p className="text-xl text-white hover:text-black transition cursor-pointer">
            Email: info@smartacharya.com
          </p>
        </div>

        {/* Navigation links row – below email */}
        <ul className="flex flex-wrap justify-center gap-y-4 font-bold text-white text-lg mb-3">
          <li
            onClick={handleFAQs}
            className="px-2 hover:text-black transition cursor-pointer border-r border-white/70 last:border-r-0"
          >
            FAQs
          </li>
          <li
            onClick={handlePrivacyPolicy}
            className="px-2 hover:text-black transition cursor-pointer border-r border-white/70 last:border-r-0"
          >
            Privacy Policy
          </li>
          <li
            onClick={handleTermsAndCondition}
            className="px-2 hover:text-black transition cursor-pointer border-r border-white/70 last:border-r-0"
          >
            T&amp;Cs
          </li>
        </ul>

        {/* Bottom row: copyright left, trading name center, social right */}
        <div className="flex flex-col sm:flex-row justify-between items-center gap-2 text-white text-sm">
          {/* Left – copyright */}
          <div className="text-center sm:text-left opacity-80 order-2 sm:order-1">
            © {new Date().getFullYear()} Smart Acharya
          </div>

          {/* Center – trading name */}
          <div className="text-md text-center order-1 sm:order-2">
             
            <p>Smart Acharya is a trading name of Acharya For Life Solutions Limited, a company registered in England and Wales</p>
            <p>(Registration No. 17241632)</p>
          </div>

          {/* Right – social icons */}
          <div className="flex justify-center space-x-4 order-3 sm:order-3">
            <a
              href={socialLinks.facebook}
              target="_blank"
              rel="noopener noreferrer"
              className="text-white hover:text-black transition"
              aria-label="Facebook"
            >
              <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                <path d="M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.879v-6.99h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.99C18.343 21.128 22 16.991 22 12z" />
              </svg>
            </a>
            <a
              href={socialLinks.instagram}
              target="_blank"
              rel="noopener noreferrer"
              className="text-white hover:text-black transition"
              aria-label="Instagram"
            >
              <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zM12 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z" />
              </svg>
            </a>
            <a
              href={socialLinks.linkedin}
              target="_blank"
              rel="noopener noreferrer"
              className="text-white hover:text-black transition"
              aria-label="LinkedIn"
            >
              <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451c.979 0 1.771-.773 1.771-1.729V1.729C24 .774 23.203 0 22.225 0z" />
              </svg>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
